import React, { useEffect, useRef, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import emailjs from '@emailjs/browser'
import Animated from '../AnimatedLetters/Animated';
import './Contact.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';

const Contact = () => {
    const [letterClass, setLetterClass] = useState('text-animate')
    const form = useRef()

    useEffect(() => {
        setTimeout(() => {
            setLetterClass('text-animate-hover')
        }, 3000)
    }, [])

    const sendEmail = (e) => {
        e.preventDefault()

        emailjs.sendForm('gmail', 'template_mvep7iq', form.current, '-D21PdVQsTR_Nhz-d')
            .then(
                () => {
                    alert('Message successfully sent!')
                    window.location.reload(false)
                },
                () => {
                    alert('Failed to send the message, please try again')
                }
            )
    }
    return (
        <Container className='contact-section'>
            <Row className="align-items-center">
                <Col xs={12} md={6} className="mb-4 mb-md-0">
                    <div className="text-zone">
                        <h1 className="text-center text-md-start">
                            <Animated
                                letterClass={letterClass}
                                strArray={['C', 'o', 'n', 't', 'a', 'c', 't']}
                                idx={15}
                            />
                        </h1>

                        <div className="contact-info mb-4">
                            <div className="contact-header">
                                <h2 className="text-warning">Get In Touch:</h2>
                                <a href="tel:+8801537249869" className="phone-link">+880 1537 249869</a>
                            </div>
                        </div>

                        <div className="contact-form">
                            <form ref={form} onSubmit={sendEmail}>
                                <ul>
                                    <li className="half">
                                        <input placeholder="Name" type="text" name="name" required />
                                    </li>
                                    <li className="half">
                                        <input
                                            placeholder="Email"
                                            type="email"
                                            name="email"
                                            required
                                        />
                                    </li>
                                    <li>
                                        <input
                                            placeholder="Subject"
                                            type="text"
                                            name="subject"
                                            required
                                        />
                                    </li>
                                    <li>
                                        <textarea
                                            placeholder="Message"
                                            name="message"
                                            required
                                        ></textarea>
                                    </li>
                                    <li>
                                        <input type="submit" className="flat-button" value="SEND" />
                                    </li>
                                </ul>
                            </form>
                        </div>

                    </div>

                </Col>
                <Col xs={12} md={6}>
                    <div className="image-container">
                        <img className='contact-image' src="https://media1.giphy.com/media/2wWBH0vXsVUmKtRJOe/giphy.gif?cid=790b76117deb884a8967eecf6ad7f302305ef6b376835106&rid=giphy.gif&ct=g" alt="Contact" />
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default Contact;